import {initWebComponent} from "@/helpers/web-component-helper";
import {isMobile} from "@/helpers/mobile-helper";

export class HeaderSettingsComponent extends HTMLElement {
    constructor(){
        super();

        const template = document.createElement('template');

        let innerHTML = ''

        if(isMobile()) {
        innerHTML = `
         <div class="btn-group dropdown-menu-right cursor-pointer">`


            innerHTML += `
            <button class="btn btn-outline-secondary btn-sm borderless popper-header text-transform-none dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                  <span class="fa fa-bars"></span>
                  <div class="popper-tooltip" role="tooltip">
                      Overige instellingen
                      <div class="arrow" data-popper-arrow></div>
                  </div>
            </button>`


        innerHTML += `   
            <div class="dropdown-menu" style="top: 38px !important;right: 30px;">`

            innerHTML += `
                  <header-right-mouse-button class="divMenuRechtermuisbutton d-none"></header-right-mouse-button>
                  <header-print class="divMenuPDF d-none"></header-print>
                  <header-notifications class="divShowAnnouncements d-none"></header-notifications>
            `


        innerHTML += `    
               
               <header-data-portal class="divDataPortal d-none"></header-data-portal>
               <div class="divLanguage d-none">
                    <header-language class="d-none d-md-block" data-key="nl" data-name="NL" data-tooltip="Verander taal"></header-language>
                </div>
            </div>
          </div>
        `
        }
        template.innerHTML = innerHTML
            initWebComponent(this, template)

    }
}
